// NotHoroscopeBar.jsx
// A slim, high-impact bar immediately below the hero.
// Directly confronts the "just another horoscope" bias before the user scrolls.
import React from "react";

export default function NotHoroscopeBar({ items = [] }) {
  if (!items?.length) return null;

  return (
    <div className="sx-nohoroscope-bar">
      <div className="sx-nohoroscope-inner">
        {items.map((item, i) => (
          <div key={i} className="sx-nohoroscope-item">
            <span className={`sx-nohoroscope-icon ${item.type === "no" ? "sx-nohoroscope-icon--no" : "sx-nohoroscope-icon--yes"}`}>
              {item.type === "no" ? "✕" : "✓"}
            </span>
            <span className="sx-nohoroscope-label">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
